;(function($) {

    'use strict';

    var pluginName = 'responsive-card-collapse';

    var defaults = {
        // callback
        activatedCallback: null,
        // class to mark card as expanded
        cardActiveClass: 'is-js-viewport-opened',
        // selector for card header
        cardHeaderSelector: '.card-header:first',
        // class to mark header as expanded
        cardHeaderActiveClass: 'is-active',
        // selector for card collapsible area
        cardCollapseSelector: '.collapse-area:first',
        // class to mark collapsible area as expanded
        cardCollapseActiveClass: 'is-active',
        // time to wait for event debounce
        debounceWait: 150,
        // trigger on startup
        triggerOnLoad: false,
        // size to trigger change
        triggerSize: 940
    };

    /**
     * Responsive Card Collapse
     * @constructor
     * @param {Object} target
     * @param {Object} options (Optional)
     */
    function ResponsiveCardCollapse(element, options) {
        this.$element = $(element);
        this.opts = $.extend({}, defaults, options);

        this._init();
    }

    /**
     * Debounce provided action
     * https://davidwalsh.name/javascript-debounce-function
     * @private
     */
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    /**
     * Check if element is currently correctly
     * @private
     */
    function alreadyToggled($element, checkClass, checkState) {
        if($element.hasClass(checkClass) && checkState == true) {
            return true;
        }

        if(!$element.hasClass(checkClass) && checkState == false) {
            return true;
        }

        return false;
    };

    /**
     * Init
     * @private
     */
    ResponsiveCardCollapse.prototype._init = function() {
        this.$window = $(window);
        this.$header = this.$element.find(this.opts.cardHeaderSelector);
        this.$collapse = this.$element.find(this.opts.cardCollapseSelector);

        this.lastWindowWidth = this.$window.width();

        this.$window.on('resize.rcc', debounce(
            $.proxy(this.sizeMonitor, this),
            this.opts.debounceWait
        ));

        if(this.opts.triggerOnLoad) {
            this.$window.trigger('resize.rcc', [true]);
        }
    };

    /**
     * Callback for the window resize event
     */
    ResponsiveCardCollapse.prototype.sizeMonitor = function(event, force) {
        var newWidth = this.$window.width();
        force = (force === undefined) ? false : force;

        if(this.crossedThreshold(this.lastWindowWidth, newWidth) || force) {
            var open = (newWidth >= this.opts.triggerSize);

            if(!alreadyToggled(this.$header, this.opts.cardHeaderActiveClass, open)) {

                this.$element.toggleClass(this.opts.cardActiveClass, open);

                this.$header
                    .toggleClass(this.opts.cardHeaderActiveClass, open)
                    .attr('aria-expanded', open ? 'true' : 'false');

                this.$collapse
                    .toggleClass(this.opts.cardCollapseActiveClass, open)
                    .attr('aria-hidden', !open ? 'true' : 'false');
            }

            if(typeof this.opts.activatedCallback === 'function') {
                this.opts.activatedCallback.call(this, open ? 'open' : 'close');
            }
        }

        this.lastWindowWidth = newWidth;
    };

    /**
     * Check if the width has crossed the toggle threshold
     */
    ResponsiveCardCollapse.prototype.crossedThreshold = function(oldWidth, newWidth) {
        return (oldWidth > this.opts.triggerSize && newWidth < this.opts.triggerSize)
            || (oldWidth < this.opts.triggerSize && newWidth > this.opts.triggerSize);
    };

    /**
     * jQuery plugin wrapper
     */
    $.fn.responsiveCardCollapse = function(options) {
        return this.each(function(){
            (new ResponsiveCardCollapse(this, options));
        });
    };

})(jQuery);